import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import axios from "axios";
import { getSession } from "next-auth/react";
import { getAppConfiguration } from "appConfig"; 

export async function getProviderList(provider?: string) {
  const query = provider ? `?id=${provider}` : "";
  return axiosFetch.get(`/api/provider${query}`);
}

export async function postProvider<T>(body: T) {
  return axiosFetch.post("/api/provider", body);
}

export async function deleteProvider(providerId: string) {
  return axiosFetch.del(`/api/provider/${providerId}`);
}

export async function uploadProviderLogo(providerId: string, file: File) {
  const appConfiguration = await getAppConfiguration();
  const session: any = await getSession();
  
  const formData = new FormData();
  formData.append('file', file);
  
  return axios.post(
    `${appConfiguration.apiUrl}/api/provider/${providerId}/logo`,
    formData,
    {
      headers: {
        'Authorization': `Bearer ${session?.accessToken}`,
      }
    }
  );
}

export async function deleteProviderLogo(providerId: string) {
  return axiosFetch.del(`/api/provider/${providerId}/logo`);
}

// FIXED: Now actually calls the API and returns the blob storage URL
export async function getProviderLogoUrl(providerId: string): Promise<string | null> {
  try {
    const appConfiguration = await getAppConfiguration();
    const response = await axios.get(
      `${appConfiguration.apiUrl}/api/provider/${providerId}/logo`
    );
    // API returns { url: "https://tvkstorage.blob..." }
    return response.data?.url || null;
  } catch (error) {
    // Return null if logo doesn't exist or any error occurs
    return null;
  }
}